<template>
  <li class="tree__list__item"
      :class="[node.favorite ? 'filter-favorite' : '',
              node.hasFavorite ? 'children-favorite' : '',
              node.isFavorite ? 'current-favorite' : '']">
    <span class="tree__list__item--label" @contextmenu="showTreeMenu($event, node)" @click="selectInTheBackend"
          :class="[
          {'active': activeNode ===   node.id},
          'level-' + node.level
          ]">
      <span class="tree__list__item--lines" @click="toggle(node)"
            :class="[
            node.childFolderIds ? 'has-children' : 'has-no-children',
            isOpen ? 'open' : '',
            'level-' + node.level
            ]">
            <span class="tree__list__item--lines__icon" v-show="node.childFolderIds">
              <p4a-icon :icon="'treeview-chevron'" />
            </span>
      </span>
      <span class="tree__list__item--icon"
            :class="[
            'level-' + node.level, node.root ? 'root' : '',
            node.template ? 'template' : '',
            node.editable ? 'is-editable' : '',
            node.project ? 'project' : '',
            node.project && node.new ? 'new-project' : '',
            node.trash ? 'trash' : ''
            ]">
      </span>
      <span class="tree__list__item--section"
            @click.prevent="activateNode(node.id)">
        {{ node.label }}
      </span>
      <div class="tree__list--icons">
        <div class="icon map-favorite" v-if="node.isFavorite"></div>
        <div class="icon map-confidential" v-if="node.isConfidential"></div>
        <div class="icon map-writable" v-if="node.isWritable"></div>
      </div>
    </span>
    <transition name="slide">
      <div v-show="isOpen">
        <ol v-show="node.children && node.children.length"
            :class="node.children && node.children.length ? 'tree-has-children' : ''">
          <div>
          <node :activeNode="activeNode"
                v-show="isOpen"
                v-for="child in node.children"
                :node="child"
                :key="child.node"
                @getPath="emitPath">
          </node>
          </div>
        </ol>
      </div>
    </transition>
  </li>
</template>

<script>
import * as treeviewApi from 'api/treeviewApi.js'
import * as treemenuApi from 'api/treemenuApi.js'
import mixins from 'mixins'

export default {
  name: 'Node',
  mixins: [mixins],
  props: {
    activeNode: String,
    node: Object
  },
  data () {
    return {
      isOpen: false
    }
  },
  created () {
    const vm = this
    // Copy Folder
    window.parent.setCopyFolder = function () {
      const folderToCopyId = vm.$store.getters.selectedFolderId
      localStorage.setItem('selectedFolderWithMethodId', folderToCopyId)
      localStorage.setItem('selectedFolderMethodType', 'copy')
    }
    // Cut Folder
    window.parent.setCutFolder = function () {
      const folderToMoveId = vm.$store.getters.selectedFolderId
      localStorage.setItem('selectedFolderWithMethodId', folderToMoveId)
      localStorage.setItem('selectedFolderMethodType', 'cut')
    }
    // Paste Folder
    window.parent.setPasteFolder = function () {
      const method = localStorage.getItem('selectedFolderMethodType')
      if (method) {
        const pasteFolderId = vm.$store.getters.selectedFolderId
        const selectedFolderWithMethodId = localStorage.getItem('selectedFolderWithMethodId')
        if (method === 'copy') {
          treemenuApi.copyFolder(selectedFolderWithMethodId, pasteFolderId).then(done => {
            vm.reloadIframe('updateTreeView')
          })
        } else if (method === 'cut') {
          treemenuApi.cutFolder(selectedFolderWithMethodId, pasteFolderId).then(done => {
            vm.reloadIframe('updateTreeView')
          })
        } else {
          alert('Method not available')
        }
        localStorage.removeItem('selectedFolderMethodType')
      }
    }
    // Delete Folder
    window.parent.setDeleteFolder = function () {
      const id = vm.$store.getters.selectedFolderId
      treemenuApi.deleteFolder(id).then(done => {
        vm.reloadIframe('updateTreeView')
      })
    }
  },
  mounted () {
    const ids = this.$store.getters.selectedNodePath
    if (ids.length < 1) {
      ids.push(-1)
    }
    ids.forEach(element => {
      if (this.node.id === element) {
        this.toggle(this.node)
      }
    })
  },
  methods: {
    emitPath (event) {
      let result = [ this.node.id ]
      if (event && event.nodePath) {
        result = result.concat(event.nodePath)
      }
      this.$emit('getPath', { nodePath: result })
    },
    fetchSelectedFolder (id) {
      // Set selected folder in the backend then save the hash response as a cookie
      return window.fetch('/Events/Folder/FolderEvents.aspx?action=treeClick&folderid=' + id, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(response => {
        return response.text()
      }).then(result => {
        if (result.indexOf('|') === 1) {
          result = result.slice(2)
          document.cookie = 'ds_h=' + result
        }
      })
    },
    showTreeMenu (e, node) {
      // Make the selected folder active by the right click
      this.activateNode(node.id)

      if (window.parent && window.parent.ContextMenuTree) {
        // Set slected folder in window for import documents
        let treeSelected = {
          SelectedNode: {
            ID: node.folderIntegerId
          }
        }
        window.parent.tree.TreeView1 = treeSelected

        // Show tree-menu in the right place
        window.parent.ContextMenuTree.ShowContextMenu(e.x, e.y + 100, node.id)

        // Set selected folder on the backend if not already did
        this.selectInTheBackend(node.folderIntegerId)

        // Save selected folder id
        this.saveSelectedFolderId(node.id, node.folderIntegerId)
      }
      e.preventDefault()
    },
    selectInTheBackend (event) {
      // Share path with parent
      this.emitPath(event)

      // Set selected folder on the backend if not already did
      const id = this.$store.getters.selectedFolderId
      if (id && id === this.node.id) {

      } else {
        this.fetchSelectedFolder(this.node.folderIntegerId)
      }
      // Save selected folder id
      this.saveSelectedFolderId(this.node.id, this.node.folderIntegerId)
    },
    saveSelectedFolderId (id, integerId) {
      this.$store.commit('setSelectedFolderId', {id, integerId})
    },
    toggle (node) {
      if (this.node.children) return (this.isOpen = !this.isOpen)
      this.$store.commit('setChildrenParentId', node.id)
      return treeviewApi.loadChildrenFolders(node.id).then(folders => {
        for (let i = 0; i < folders.length; i++) {
          folders[i].root = false
          folders[i].level = node.level + 1
          folders[i].id = folders[i].folderId
          folders[i].label = folders[i].folderName
        }
        node.children = folders
        if (this.node.childFolderIds) {
          this.isOpen = !this.isOpen
        }
      })
    },
    activateNode (node) {
      this.$eventBus.$emit('updateNodes', node)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/treeView/treeNode.vue